// EyeOffIcon.tsx
import { Icon, IconProps } from "@chakra-ui/react";

export const EyeOffIcon = (props: IconProps) => (
  <Icon viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M9.53 9.53C9.01938 10.0406 8.73756 10.7666 8.75 11.52C8.76244 12.2734 9.06804 12.9876 9.61803 13.5376C10.168 14.0876 10.8822 14.3932 11.6356 14.4056C12.389 14.418 13.115 14.1362 13.6256 13.6256M16.24 16.24C14.9606 17.1607 13.3636 17.6727 11.72 17.67C7.72001 17.67 4.39001 14.92 2.46001 10.66C3.34243 8.70374 4.69908 6.98417 6.43 5.66M9.88 4.60999C10.48 4.50999 11.1 4.45999 11.72 4.45999C15.72 4.45999 19.05 7.20999 20.98 11.47C20.3518 12.8716 19.5066 14.1707 18.48 15.32M3 3L21 21"
      stroke="#344054"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);
